<script lang="ts" setup>
	defineProps<{
		iconName: string
		iconDir: string
		caption: string
		isEmpty?: boolean
	}>()
	defineEmits<{
		(event: 'open'): void
	}>()
</script>

<template>
	<div class="relative mx-auto min-h-[320px] w-full max-w-[440px] rounded-lg border border-gray-200 bg-gray-50 p-5">
		<div
			v-if="isEmpty"
			class="flex h-[280px] w-full cursor-pointer flex-col items-center justify-center space-y-4 rounded-lg border-[2.5px] border-dashed border-primary-2"
			@click="$emit('open')"
		>
			<lazy-tools-icon :dir="iconDir" :icon="iconName" :height="80" :width="80" path-class="fill-gray-400" />
			<p class="text-gray-500 sm:text-base">
				{{ caption }}
			</p>
			<slot name="empty" />
		</div>
		<slot v-else />
	</div>
</template>
